import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction, useEditOrderSvc } from '../service'

import { useForm } from 'react-hook-form'
import * as R from 'ramda'

export function EditDeliveryAddress(props: { onClose: () => void; onSave: (action: EditOrderAction) => void }): JSX.Element {
  const editOrderSvc = useEditOrderSvc()
  const address = editOrderSvc.getOrderAddress()
  const form = useForm({
    mode: 'onBlur',
    defaultValues: R.omit(['id', '__typename'], address),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any) => {
    console.log("Data", data)
    props.onSave({ op: 'update-delivery_address', address: { ...data, full_address: `${data.street}, ${data.block || ''} ${data.city}, ${data.state} ${data.zip}` } })
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Update Address</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="info">
            Fix delivery address below.
          </div>
          <div className="form-group">
            <label htmlFor="value">Street:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.street ? { color: 'red' } : {}}
              type="text"
              {...register('street', {
                required: 'is required',
              })}
            />
            {errors && errors.street && <span className="text-danger">{errors.street.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="value">Block:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.block ? { color: 'red' } : {}}
              type="text"
              {...register('block', {})}
            />
            {errors && errors.block && <span className="text-danger">{errors.block.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="value">City:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.city ? { color: 'red' } : {}}
              type="text"
              {...register('city', {
                required: 'is required',
              })}
            />
            {errors && errors.city && <span className="text-danger">{errors.city.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="value">State:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.state ? { color: 'red' } : {}}
              type="text"
              {...register('state', {
                required: 'is required',
              })}
            />
            {errors && errors.state && <span className="text-danger">{errors.state.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="value">Zip:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.zip ? { color: 'red' } : {}}
              type="text"
              {...register('zip', {
                required: 'is required',
              })}
            />
            {errors && errors.zip && <span className="text-danger">{errors.zip.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="value">Cross street:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.cross_street ? { color: 'red' } : {}}
              type="text"
              {...register('cross_street')}
            />
            {errors && errors.cross_street && <span className="text-danger">{errors.cross_street.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="value">Delivery instructions:</label>
            <input
              className="form-control input input-small"
              style={errors && errors.delivery_instructions ? { color: 'red' } : {}}
              type="text"
              {...register('delivery_instructions')}
            />
            {errors && errors.delivery_instructions && <span className="text-danger">{errors.delivery_instructions.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">Save</Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
